import type { EntityData } from '@ContractBuilder/types';

interface BlockCommentsCount {
  total: number;
  unresolved: number;
}

export const getBlockCommentsCount = (blockId: string, submission?: EntityData): BlockCommentsCount => {
  if (!submission?.comments) {
    return { total: 0, unresolved: 0 };
  }

  const blockComments = submission.comments.filter((comment) => comment.block_id === blockId);

  return {
    total: blockComments.length,
    unresolved: blockComments.filter((comment) => !comment.is_resolved).length,
  };
};
